import { BRANCH_GROUP_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Branch Group Id",
    field: "branchGroupId",
    width: 200,
  },
  {
    headerName: "Branch Group",
    field: "name",
    width: 300,
  },
  {
    headerName: "Branch Names",
    field: "branchCode",
    width: 800,
  },
];

export const transformPayload = (branch) => {
  return {
    branchGroupId: branch?.branchGroupId || undefined,
    name: branch?.name,
    branchCode: branch?.branches || [],
  };
};
export const columnDefsFunctions = {
  branchCode: {
    valueGetter: (params) => {
      const branchCode = params.data.branchCode;
      if (!Array.isArray(branchCode) || branchCode.length === 0) {
        return "";
      }
      return branchCode.map((branchCode) => branchCode).join(",");
    },
  },
};

export const initial_state_branch_group = {
  type: BRANCH_GROUP_TAB,
  label: "Branch Group Master",
  allowMultipleTabs: false,
};
